import { Typography } from "@mui/material";

import PageTabsV2 from "@/App/Layouts/PageBody/PageTabsV2";
import SimpleViewPageHeader from "@/App/Layouts/PageHeader/SimpleViewPageHeader";
import { ViewLayout } from "@/App/Layouts/ViewLayout";
import { VehicleDamageDataDtoAny } from "@/common/mapping/mappers/vehicleDamage";
import { AppPermission, EntityDataOriginMode, EntityType } from "@/core/api/generated/v1";

import {
  BaseEntityDataView,
  BaseEntityDataViewInheritableProps,
} from "../../components/BaseEntityDataView";
import OverviewTabContent from "./Tabs/OverviewTabContent";
import VehicleTabContent from "./Tabs/VehicleTabContent";
import VehicleDamageView, {
  VehicleDamageViewPageTabs,
  defaultDisplayProps,
  defaultHeaderProps,
} from "./VehicleDamageView";

interface OwnProps extends BaseEntityDataViewInheritableProps<VehicleDamageDataDtoAny> {
  headerProps?: Partial<typeof defaultHeaderProps>;
  displayProps?: Partial<typeof defaultDisplayProps>;
}

export type VehicleDamageDataViewProps = OwnProps;

export default function VehicleDamageDataView({
  entityData,
  headerProps = defaultHeaderProps,
  displayProps = defaultDisplayProps,
}: VehicleDamageDataViewProps) {
  displayProps = { ...defaultDisplayProps, ...displayProps };

  if (entityData && entityData.dataOriginMode === EntityDataOriginMode.Ref && entityData.id) {
    return (
      <VehicleDamageView
        vehicleId={entityData.vehicleId}
        vehicleDamageId={entityData.id}
        vehicleDamage={undefined}
        headerProps={headerProps}
        displayProps={displayProps}
        onDelete={null}
      />
    );
  }

  return (
    <BaseEntityDataView entityType={EntityType.VehicleDamage} entityData={entityData}>
      <ViewLayout
        displayProps={displayProps}
        header={
          displayProps.header &&
          entityData && (
            <SimpleViewPageHeader
              title={
                <Typography
                  component='div'
                  variant='h1'
                  sx={{ display: "flex", alignItems: "center" }}
                  {...headerProps?.typographyProps}
                >
                  {headerProps?.title || (
                    <>
                      <span>Local damage data</span>&nbsp;
                      {/* <AppLink
                        isEnabled={headerProps?.withLink && !!entityData.id}
                        to={ROUTE_PATH.VEHICLE_DAMAGE_VIEW({
                          vehicleId: entityData?.vehicleId || undefined,
                          vehicleDamageId: entityData?.id || undefined,
                        })}
                      >
                        <span>{entityData?.localNumber}</span>
                      </AppLink> */}
                    </>
                  )}
                </Typography>
              }
              primaryActions={undefined}
            />
          )
        }
      >
        <PageTabsV2
          tabIdsDefinition={VehicleDamageViewPageTabs}
          defaultTabId={VehicleDamageViewPageTabs.Overview}
          viewVariant={displayProps?.viewVariant}
          tabs={[
            { label: "Overview", value: VehicleDamageViewPageTabs.Overview, isHideable: false },
            {
              label: "Vehicle",
              value: VehicleDamageViewPageTabs.Vehicle,
              permissions: [AppPermission.VehicleRead],
            },
          ]}
        >
          {({ activeTabId: activeTab }) =>
            entityData && (
              <>
                {activeTab === VehicleDamageViewPageTabs.Overview && (
                  <OverviewTabContent entity={entityData} displayProps={displayProps} />
                )}
                {activeTab === VehicleDamageViewPageTabs.Vehicle && (
                  <VehicleTabContent entity={entityData} />
                )}
              </>
            )
          }
        </PageTabsV2>
      </ViewLayout>
    </BaseEntityDataView>
  );
}
